"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORM_FIELD_NO_ERROR = void 0;
exports.FORM_FIELD_NO_ERROR = {
    hasErrors: false,
    message: null,
};
